import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { afterItems, beforeItems, differenceStats } from '../data/matematik';
export function Difference() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-66" data-mp="e3dgfowuf8og">
      <div className="mx-auto max-w-6xl" data-id="element-67" data-mp="9vyg8jt240j">
        <header className="grid gap-8 lg:grid-cols-12 lg:items-end" data-id="element-68" data-mp="58z6m1v30qcq">
          <div className="lg:col-span-7" data-id="element-69" data-mp="574gm94ye81s">
            <p className="font-serif text-2xl italic leading-none text-rose-600" data-id="element-70" data-mp="3mgugxw4z8jv3">Forskellen med BILLEDKLAR™</p>
            <h2 className="mt-4 font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-71" data-mp="3rhi8cix4b2pu">
              Fra presset lærer <em className="text-rose-600" data-id="element-72" data-mp="3diiix91s6jsm">til rolig og velforberedt.</em>
            </h2>
          </div>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-5" data-id="element-73" data-mp="3ihv7by8avyxb">
            Forestil dig at starte ugen med billedkunst allerede klar. Du ved, hvad du skal
            undervise i – og du har lektionerne, materialelisterne, elevark i 3 niveauer
            og evalueringen.
          </p>
        </header>

        <dl className="mt-14 grid border-t border-slate-900/15 sm:grid-cols-3" data-id="element-74" data-mp="1f9k5kbpjm8x0">
          {differenceStats.map((stat, index) => <div key={stat.label} className={`flex flex-col-reverse py-6 sm:pr-8 ${index > 0 ? 'border-t border-slate-900/10 sm:border-l sm:border-t-0 sm:pl-8' : ''}`} data-id="element-75" data-mp="1t1i823or16k7" data-mpi={index}>
              <dt className="mt-1.5 text-sm leading-snug text-slate-900/70" data-id="element-76" data-mp="1o489nyjdtkk8">{stat.label}</dt>
              <dd className="font-serif text-3xl leading-tight text-slate-900" data-id="element-77" data-mp="10e4fsivzwz6f">{stat.value}</dd>
            </div>)}
        </dl>

        <div className="mt-14 grid gap-5 lg:grid-cols-2" data-id="element-78" data-mp="1ab0exy0088yb">
          <article className="rounded-3xl border border-slate-900/10 bg-stone-100 p-8 sm:p-11" data-id="element-79" data-mp="1a8e860kxtxh5">
            <p className="text-sm font-semibold text-slate-900/60" data-id="element-80" data-mp="15a31fypxw335">Før BILLEDKLAR™</p>
            <h3 className="mt-2 font-serif text-3xl leading-tight text-slate-900/80 sm:text-4xl" data-id="element-81" data-mp="2lo2wowdub4k2">
              Kender du det?
            </h3>
            <ul className="mt-8 divide-y divide-slate-900/10 border-t border-slate-900/10" data-id="element-82" data-mp="2orisltmi9qtp">
              {beforeItems.map(item => <li key={item.title} className="flex gap-4 py-4 text-[15px] leading-relaxed text-slate-900/70" data-id="element-83" data-mp="2ssaz4f3zthma">
                  <XIcon className="mt-1 h-4 w-4 shrink-0 text-slate-900/40" aria-hidden="true" data-id="element-84" data-mp="2xsyrb43yk4i3" />
                  <span data-id="element-85" data-mp="32pyxdf0t5797">
                    <span className="block font-semibold text-slate-900/80" data-id="element-86" data-mp="32qi7i9k7urco">{item.title}</span>
                    {item.text}
                  </span>
                </li>)}
            </ul>
          </article>

          <article className="rounded-3xl bg-slate-900 p-8 text-stone-50 shadow-2xl shadow-slate-900/30 sm:p-11" data-id="element-87" data-mp="2a2maf3qqixfd">
            <p className="text-sm font-semibold text-rose-300" data-id="element-88" data-mp="2ezmhnhzbm682">Med BILLEDKLAR™</p>
            <h3 className="mt-2 font-serif text-3xl leading-tight sm:text-4xl" data-id="element-89" data-mp="2jtgymdnjk73g">
              Mindre planlægning. Mere undervisning.
            </h3>
            <ul className="mt-8 divide-y divide-white/10 border-t border-white/10" data-id="element-90" data-mp="1rbbjwnox8mo0">
              {afterItems.map(item => <li key={item} className="flex gap-4 py-4 text-[15px] leading-relaxed text-stone-50/90" data-id="element-91" data-mp="1jslx4oh0g0jb">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-rose-600" data-id="element-92" data-mp="1euanoeumns1m">
                    <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-93" data-mp="19sl9wrg0t09u" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </article>
        </div>

        <p className="mx-auto mt-14 max-w-2xl text-center font-serif text-2xl italic leading-snug text-slate-900/80 sm:text-3xl" data-id="element-94" data-mp="10vknurgfbe9k">
          Fokusér på dine elever – i stedet for at lave alt materialet selv.
        </p>
      </div>
    </section>;
}